module.exports = __webpack_public_path__ + "img/MDMskd.a9d32673.jpg";